<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        検出
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">検出</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> 検出日
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="レベル" label-for="code_ext" v-b-tooltip.hover>
              <b-form-checkbox-group v-model="so.opt['level']" @change="refresh">
                <b-form-checkbox value="H">危険</b-form-checkbox>
                <b-form-checkbox value="W">警告</b-form-checkbox>
                <b-form-checkbox value="N">注意</b-form-checkbox>
                <b-form-checkbox value="S">疑惑</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Type" label-for="code_type" v-b-tooltip.hover>
              <b-form-checkbox-group v-model="so.opt['type']" @change="refresh">
                <b-form-checkbox value="U">URL</b-form-checkbox>
                <b-form-checkbox value="S">String</b-form-checkbox>
                <b-form-checkbox value="R">Regex</b-form-checkbox>
                <b-form-checkbox value="M">MD5</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">一致タイプ</label>
            <b-form-group>
              <b-form-radio-group v-model="so.opt['match_type']" @change="($event) = so.opt = Object.assign({}, so.opt, { match_type : $event })" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:すべて一致</b-form-radio>
                <b-form-radio value="or">[OR]:最低でも1つは一致</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button class="btn-add" size="sm" variant="success" @click="refresh"> 検索 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> リセット </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 閉じる </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->

      <b-row>
        <b-col sm="12">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || '検索'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='domain';so.skt='FQDN';so.adv=false;so.sv=''">FQDN</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='code';so.skt='Code';so.adv=false;so.sv=''">コード</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='url';so.skt='Page';so.adv=false;so.sv=''">ページ</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> 詳細検索</i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="12">
          * <b-badge variant="danger">高い</b-badge>
          <!-- <span class="badge badge-pill badge-danger">危険</span> -->
          : 悪意のあるコードを拡散させるリスクが高い
          <br>
          * <b-badge variant="warning">中</b-badge>
          : 悪意のあるコードは存在しないが、最近検出された経緯があり、リスクがある
          <br>
          * <b-badge variant="primary">低い</b-badge>
          マルウェアが存在しないが、自動的にダウンロードされたり、別のページに再移動することがあり、注意が必要:
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="domain" slot-scope="row">{{row.item.domain}}</template>
        <template slot="url" slot-scope="row">
          <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
            {{row.item.url | truncate(40)}}
          </a>
        </template>
        <template slot="level" slot-scope="row">
          <b-badge variant="danger" v-if="codes.WMDS_LEVEL(row.item.level, 'EN') == 'high'"> {{codes.WMDS_LEVEL(row.item.level, "EN")}}</b-badge>
          <b-badge variant="primary" v-else> {{codes.WMDS_LEVEL(row.item.level, "EN")}}</b-badge>
        </template>
        <template slot="type" slot-scope="row">{{codes.WMDS_TYPE[row.item.type]}}</template>
        <template slot="code" slot-scope="row">{{row.item.code | truncate(40)}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime }}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">詳細</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
